import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toastr } from 'react-redux-toastr';

import { validateVoiceItem } from '../../../util/validateVoiceItem';
import { BotsCreators } from '../../../store/actions/bots';
import ConfirmPublishDialog from './ConfirmPublishDialog';

const Publish = ({ bot, items }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [viewer, setViewer] = useState(false);

  const debounceList = useSelector((state) => state.debounce?.list);
  const connectors = useSelector((state) => state.connectors?.list);
  const userClaim = useSelector(
    (state) => state.users?.signedUser?.selectedCompany?.claim?.name
  );

  useEffect(() => {
    if (userClaim && userClaim === 'Viewer') {
      setViewer(true);
    }
  }, []);

  const dispatch = useDispatch();

  function isValidVoicebot() {
    if (!items?.length) return false;
    return !items.some((item) => !validateVoiceItem({ item, connectors }));
  }

  const handleConfirmPublish = ({ isActive }) => {
    setModalIsOpen(false);

    const isVoiceBot = bot?.type === 'voice';
    if (isVoiceBot) {
      dispatch(BotsCreators.publishVoiceBot(bot._id));
      return;
    }

    dispatch(BotsCreators.publishBot(bot._id, isActive));
  };

  const onClickPublishBot = () => {
    if (!viewer) {
      if (Array.isArray(debounceList) && debounceList.length > 0) {
        toastr.warning(
          'Atenção',
          'Seu bot está sendo salvo, aguarde esse processo para publicar'
        );
      } else {
        setModalIsOpen(true);
      }
    }
  };

  return (
    <>
      <button
        type="button"
        className="publish-btn"
        onClick={onClickPublishBot}
        disabled={bot?.type === 'voice' ? !isValidVoicebot() : false}
      >
        Publicar
      </button>

      {modalIsOpen && (
        <ConfirmPublishDialog
          bot={bot}
          isOpen={modalIsOpen}
          onClose={() => setModalIsOpen(false)}
          onSubmit={handleConfirmPublish}
        />
      )}
    </>
  );
};

export default Publish;
